var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-card', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Upload Locations")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Back to Upload Location List"
    },
    on: {
      "click": _vm.showUploadLocationList
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "style": "font-size:18px"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Client Name")]), _vm._v(" "), _c('b-input-group', [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.companyNamelist,
      "name": "companyName",
      "placeholder": "Select Client Name",
      "label": "text",
      "track-by": "value",
      "multiple": false,
      "scroll": true
    },
    on: {
      "select": _vm.selectCompanyName
    },
    model: {
      value: (_vm.companyName),
      callback: function($$v) {
        _vm.companyName = $$v
      },
      expression: "companyName"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clienterr),
      expression: "clienterr"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.clienterr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Upload For")]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('div', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationtype),
      expression: "locationtype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "pickuplocations",
      "value": "pickuplocations",
      "name": "uploadtype"
    },
    domProps: {
      "checked": _vm._q(_vm.locationtype, "pickuplocations")
    },
    on: {
      "__c": function($event) {
        _vm.locationtype = "pickuplocations"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _c('label', {
    attrs: {
      "for": "pickuplocations"
    }
  }, [_vm._v("Pickup Locations ")]), _vm._v("     \n              ")]), _vm._v(" "), _c('div', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationtype),
      expression: "locationtype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "consigneelocations",
      "value": "consigneelocations",
      "name": "uploadtype"
    },
    domProps: {
      "checked": _vm._q(_vm.locationtype, "consigneelocations")
    },
    on: {
      "__c": function($event) {
        _vm.locationtype = "consigneelocations"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _c('label', {
    attrs: {
      "for": "consigneelocations"
    }
  }, [_vm._v("Consignee Locations")])])])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.uploadtypeerr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Product Attachment ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    staticClass: "file-upload"
  }, [_c('label', {
    attrs: {
      "for": "files"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "title": "Upload Document",
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    ref: "file",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xlsx,.xls",
      "name": "XLFile",
      "id": "files"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload($event.target.files)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fileerror),
      expression: "fileerror"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.fileerror))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v("Allowed file types are .xlsx")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-secondary",
    attrs: {
      "type": "button"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "href": "../../../../../../static/Cargo_locations_SampleFile.xlsx"
    }
  }, [_vm._v("Sample File")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.UploadProduct
    }
  }, [_vm._v("Upload")]), _vm._v(" \n            ")])])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ba5a386","hasScoped":true}!./src/modules/clientmanagement/views/ClientLocations/UploadLocations/UploadLocations.component.html
// module id = 759
// module chunks = 3